import styled from 'styled-components';
// import {StyledTabs} from '../CompanyDashBoardV2/styles';
const BoldFont = 'lato';
const MediumFont = 'lato'; 

import { Modal } from 'react-bootstrap';
const StyledModal = styled(Modal)`
  
  .modal-dialog {
    width: auto;
    right: 0px;
    margin: 0px;
    position: absolute;
  }
  .modal-open {
    overflow: hidden;
}
`

const NotificationWrapper =  styled.div`
overflow: hidden;
position: absolute;
top: 0;
border-radius: 6px;
z-index: 1999;
box-shadow: 1px 1.732px 12px rgb(0 0 0 / 18%);
background-color: #fff;
width: 350px;
width: 375px;
min-height: 100%;
right:0px;
.wrapper-class{
  position: relative;
  overflow: hide;
  height: 100vh;
  overflow: hidden;
    top: 65px;
}
.scroll-hide {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: -17px; /* Increase/Decrease this value for cross-browser compatibility */
  // overflow-y: scroll;

}
  .read{
    background-color: #fff; 
  }

  @media (max-width: 350px) {
    width: 100%;
  }
`;
const TitleContainer = styled.div`
width: 100%;
min-height: 70px;
height: 15%;
background: linear-gradient(180deg, #52A8ED 0%, #8AD3F7 100%);
padding: 35px 15px 0px 15px;
// text-transform: uppercase;
color: #FFFFFF;
font-family: 'lato';
font-size: 16px;
line-height: 24px;
overflow: hidden;
    position: absolute;
    height: 35px;
`;
const UserImage = styled.div`
width: 100%;
display: flex;
justify-content: space-between;
padding: 15px;
border-bottom: 1px solid rgba(156, 156, 156, 30%);
> div:first-child {
  width: auto;
  > img {
    width: 112px;
    height: 112px;
    border-radius: 6px;
  }
}
> div: last-child {
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  padding: 5px 15px;
  gap: 10px;
  > div: first-child {
    color: #0D4270;
    font-family: 'lato';
    font-style: normal;
    font-size: 18px;
    line-height: 24px;
  }
  > div: nth-child(2){
    color: #C6C6C6;
    color: #9c9c9c;
    font-family: lato;
    font-size: 16px;
    line-height: 24px;
  }
  > button {
    background: #EAF6FF;
    border-radius: 3px;
    outline: none;
    border: none;
    height: 50px;
    width: 80%;
    color: rgba(105, 194, 255, 1);
    font-family:lato;
    // align-self: flex-start;
  }
}
`;
const WellnessIntereset = styled.div`
padding: 15px;
border-bottom: 1px solid rgba(156, 156, 156, 30%);
> div: first-child {
  display: flex;
  justify-content: space-between;
  color: #0D4270;
  font-family: lato;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 15px;
  >p{
    color: #0D4270;
    font-family: lato;
    font-size: 18px;
    line-height: 24px;
    display: inline;
    margin: 0px;
  }
  >span{
    margin-right: 15px;
    >a{
      font-family: 'lato';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      color: #7DC5FF;
      padding-left: 120px;
      cursor: pointer;
      text-decoration: none;
    }
  }
}
> div: last-child {
  display: flex;
  justify-content: flex-start;
  > div{
    width: 40px;
    height: 40px;
    background: linear-gradient(360deg, #1E6481 0%, #0D425C 60.94%, #022C43 100%);
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    > img {
      width: 70%;
      height: 70%;
    }
  }
}
`;
const Content = styled.div`
width: 100%;
display: flex;
justify-content: space-between;
min-height: 50px;
margin-bottom: 10px;
cursor: pointer;
> div: first-child {
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  // background-color: #F9F9F9;
  > img {
    width: 45%;
    width: 40px;
    height: 40px;
  }
}
>div: last-child {
  width: 100%;
  margin: auto;
  > div: first-child {
    font-size: 16px;
    line-height: 16px;
    font-family: 'lato';
    color: #0D4270;
    &:hover, &:focus, &:active {
      text-decoration: none;
    }
  }
  > div: last-child {
    font-size: 14px;
    line-height: 14px;
    color: #CCCCCC;
    font-family: 'lato';
    color: #9c9c9c;
  }
}
&:last-child{
  margin-bottom: 0px;
}

.add-slack{
  font-size: 16px;
    line-height: 16px;
    font-family: 'lato';
    color: #0D4270;
    cursor:pointer;
    text-decoration: none;
    a{
      font-size: 16px;
    line-height: 16px;
    font-family: 'lato';
    color: #0D4270;
    cursor:pointer;
    text-decoration: none;

    }
}
`;
const WellnessInitiative = styled.div`
width: 100%;
padding: 15px;
> div: first-child {
  color: #0D4270;
  font-family: lato;
  font-size: 18px;
  line-height: 24px;
}
`;

const WellnessInitiativeRow = styled.div`
  display: flex;
  padding: 15px 0;
  border-bottom: 2px solid #F6F6F8;
  > div {
    width: 100%;
    float: left
    .fixedIcon {
      >svg {
        max-width: 23px;
        width: 100%;
        overflow: hidden;
        height: 100%;
        float: left;
      }
      >img {
        max-width: 50px;
        width: 100%;
        overflow: hidden;
        height: 50px;
        float: left
        margin-right: 5px;
      }
    }
    .secondGrid {
      padding-right: 5px;
      padding-left: 5px;
      word-break: break-all;
      float: left;
      width: calc(100% - 80px);
    }
    .thirdGrid {
      font-family: ${BoldFont};
      font-size: 15px;
      float: right;
    }
  }
    
    > div {
      > div {
        font-size: 12px;
        color: rgb(153,153,153);
      }
    }
  }

`;
const InitiativeTitle = styled.span`
  font-size: 15px;
  line-height: 19px;
  letter-spacing: 0px;
  color: ${({ color }) => color ? color : 'rgb(51,51,51)'};
  font-family: ${BoldFont};
	color: #282C37;
`;

const WellnessPoint = styled.div`
  height: 20px;
  border-radius: 3.072px;
  display: flex;
  justify-content: flex-start;
  color:${({color}) => color};
  font-family: ${MediumFont};
  font-size: 13px;
  line-height: 17px;
`;
const TickWrapper = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  > img {
    width: 100%;
  }
`;
const Container = styled.div`
width: 100%;
height: 100%;
padding: 15px;
border-bottom: 1px solid #F3F3F3;
`;
const LocationContainer = styled.div`
  color: #C6C6C6;
  color: #9c9c9c;
  font-family: lato;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;
  > div: first-child {
    > img {
      width: 14px;
      margin-right: 7px;
    }
  }
`;

const AboutCard = styled.div`
  .about-user-section{
    width: 100%;
    background: #FFFFFF;
    border-radius: 6px;
    margin: 0px 0px 25px;
  }
  .title-text{
    padding: 17px 25px;
    font-family: 'lato';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .user-edit-btn{
      background: #FD7175;  
      width: 150px;
      height: 40px;
      border-radius: 3px;
      color: white;
      border:none;
      font-size:18px;
      font-family: "lato";
      align-items: center;
      display: flex;
      margin: auto;
      margin-right: 0px;
      text-align: center;
      justify-content: center;
   }
  }
  .about-user-details{
    padding: 25px;
    font-family: 'lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #0D4270;
  }
  .horizontal-line{
    height: 1px;
    background: rgba(156, 156, 156, 0.4);
    color: #9C9C9C;
    margin-top: unset;
    margin-bottom: unset;
    border: 0px;
  }  
`;

const WellnessCard = styled.div`
  .wellness-interest{
    margin: 0px 0px 25px;
    max-width: 1246px;
    background-color:#FFFFFF;
    border-radius: 6px;
  }
  .wellness-title{
    padding: 17px 25px;
    display: flex;
    .user-edit-btn{
      background: #FD7175;  
      min-width: 150px;
      height: 40px;
      border-radius: 3px;
      color: white;
      border:none;
      font-size:18px;
      font-family: "lato";
      align-items: center;
      display: flex;
      margin: auto;
      margin-right: 0px;
      text-align: center;
      justify-content: center;
   }
  }
  .title-text{
    font-family: 'lato';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #0D4270;    
    margin-right: 25px;
    display: flex;
    align-items: center;
  }
  .wellness-count{
    font-family: 'lato';
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;    
    color: #FD7175;
    display: flex;
    align-items: center;
  }
  .interest-card-wrapper{
    padding:25px;
    padding-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
  }
  .horizontal-line{
    background: rgba(156,156,156,0.4);
    height: 1px;
    margin-top: unset;
    margin-bottom: unset;
    border: 0px;
  } 
  .interest-card{
    width: calc((100% - 75px) / 4);
    height: 60px;
    border: 1px solid #9C9C9C;
    border-radius: 7px;
    margin-bottom: 20px;
  }

  .icon-wrapper{
    display: flex;
    align-items: center;
    padding: 10px;
  }
  .interest-card{
  display:flex;
  }
  .interest-icon{
    height: 40px;
    width: 40px;
    display: flex;
    background: #0D4270;
    align-items: center;
    border-radius: 6px;
    >img{
      width: 25px;
      height: 25px;
      margin: auto;
    }
  }
  .interest-name{
    display: flex;
    align-items: center;
    font-family: 'lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #0D4270;
  }
`;

const StyledModalV2 = styled(Modal)`
	.modal-dialog{
		display: flex;
    justify-content: center;
    transform: ${({transform}) => transform && 'translate(0, 50vh) translate(0, -50%) !important'};
		.modal-content{
			width: 100%;
      border-radius: 10px;
      border: none;
			.modal-header {
				border-bottom: ${({noBorder}) => noBorder ? noBorder : '1px solid #e5e5e5'};
        background: linear-gradient( 
          180deg,#52A8ED 0%,#8AD3F7 100%);

				> div {
					display: flex;
					justify-content: center;

					> p{
						font-size: 20px;
						font-family: ${BoldFont};
						margin-top: 10px 0 0 0;
					}
				}
			}
			.modal-header .close {
				//margin-top: -2px;
				outline: none;
        float: right;
        margin-top: -21px;
        margin-right: 2px;
       color: white;
       font-size: 44px;
        opacity: 0.9;
			}
		}
	}
  @media (max-width: 500px) and (min-width: 320px) {
    .modal-dialog {
			width: 100%;

			.modal-content{
				width: 90%;
				margin-left: -6%;
			}
    }
  }
`;

const StyledModalV3 = styled(Modal)`
	.modal-dialog{
		display: flex;
    justify-content: center;
    transform: ${({transform}) => transform && 'translate(0, 50vh) translate(0, -50%) !important'};
		width: 1026px;
    .modal-content{
			width: 100%;
      border-radius: 10px;
      border: none;
      width: 1026px;
			.modal-header {
				border-bottom: ${({noBorder}) => noBorder ? noBorder : '1px solid #e5e5e5'};
        background: linear-gradient( 
          180deg,#52A8ED 0%,#8AD3F7 100%);

				> div {
					display: flex;
					justify-content: center;

					> p{
						font-size: 20px;
						font-family: ${BoldFont};
						margin-top: 10px 0 0 0;
					}
				}
			}
			.modal-header .close {
				//margin-top: -2px;
				outline: none;
        float: right;
        margin-top: -21px;
        margin-right: 2px;
       color: white;
       font-size: 44px;
        opacity: 0.9;
			}
		}
	}
  @media (max-width: 500px) and (min-width: 320px) {
    .modal-dialog {
			width: 100%;

			.modal-content{
				width: 90%;
				margin-left: -6%;
			}
    }
  }
`;

const StyledBody = styled(Modal.Body)`
  padding: 20px 25px 0px 25px;
`;

const WbaCardContainer = styled.div`
  width: 100%
  display: flex;
  justify-content: space-between,
`;

const FirstRowCard = styled.div`
  width: 40%
  text-align: center;
`;

const FirstRowCardV2 = styled.div`
  // width: 40%
  text-align: center;
`;

const LastImprovementRow = styled.div`
  width: 20%
  text-align: center;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  .first{
    font-family: 'lato';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #0D4270;
    text-align: center;
    margin-bottom: 47px !important;
  }
  .second{
    font-family: 'lato';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #9D87A9;
    margin-bottom: 60px;
  }
  .third{
    font-family: 'lato';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #69C2FF;
    margin-bottom: 60px;
    // margin-top: 20px !important;
  }
  .fourth{
    font-family: 'lato';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #9FC989;
    margin-bottom: 60px;
    // margin-top: 20px !important;
  }
  .fifth{
    font-family: 'lato';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #F8A887;
    margin-bottom: 60px;
    // margin-top: 10px !important;
  }
  .sixth{
    font-family: 'lato';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #F6B479;
    margin-bottom: 45px;
    // margin-top: 20px;
  }
  .seventh{
    font-family: 'lato';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: white;
    // margin-bottom: 60px;
    // margin-top: 20px;
  }

`;

const TopInfo = styled.div`
  font-family: 'lato';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #9C9C9C;
`;

const AboutTextBox = styled.textarea`
  width: 100%;
  height: 219px;
  background: #FFFFFF;
  border: 1px solid rgba(156, 156, 156, 0.4);
  border-radius: 6px;
  margin-top: 25px;
  margin-bottom: 25px; 
  background: rgba(156, 156, 156, 0.1);
  border: 1px solid rgba(156, 156, 156, 0.4);
  border-radius: 3px;
  font-family: lato;
  padding: 13px 15px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #0D4270;
  width: 100%;
  outline: none;           
`;

const SaveAboutButton = styled.div`
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    border-top: 1px solid #e5e5e5;
    .savebutton{
      display: flex;
      justify-content: center;
      align-items: center;
      border: none;
      background: #FD7175;
      border-radius: 3px;
      width: 200px;
      height: 50px;
      font-family: lato;
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
      color: rgb(255, 255, 255);
    }
`;

const OverviewCard = styled.div`
    max-width: 1246px;
    height: 325px;
    background-color:#FFFFFF;
    border-radius: 6px;
    margin-bottom: 25px;
    .detail-button{
    min-width: 150px;
    height: 40px;
    background: #FD7175;
    border-radius: 3px;
    margin-right: 25px;
    border: none;
    color: #ffffff;
    font-family:lato;
    font-size: 18px;
    line-height: 24px;
   }
.viewcard{
    display:flex;  
    justify-content:space-between;
    
  }
   .prof-details{
      width:100%;
      display:flex;
      justify-content:space-between;
      padding: 0px 25px 0px 25px;
      height:74px;
      align-items:center;
   }
   .name-in{
    display: flex;
    font-family:"lato";
      font-style: normal;
      align-items: center;
      color: #0D4270;
      font-size: 18px;
      line-height: 24px;
   }
    .horizontal-line{
        background: rgba(156, 156, 156, 0.4);
        margin-bottom: 25px;
        margin-top: 0px;
        height: 1px
    }
    .user-edit-btn{
      background: #FD7175;  
      width: 150px;
      height: 40px;
      border-radius: 3px;
      color: white;
      border:none;
      font-size:18px;
      font-family: "lato";
      align-items: center;
      display: flex;
      margin: auto;
      margin-right: 0px;
      text-align: center;
      justify-content: center;
   }
   .emp-detail{
    font-family: 'lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    display:flex;
    flex-wrap:wrap;
    display: flex;
    flex-direction: row;
    padding: 0px 25px;
    
    .fieldNames{
        width:50%;
        display: flex;
        height: 40px;
        .color{
          color:#FD7175;
          font-family: 'lato';
          font-size: 16px;
          line-height: 20px;
        }
        .green{
          color: #9FC989;
          font-family: 'lato';
          font-size: 16px;
          line-height: 20px;
        }
        .prof-data{
          color:#0D4270;
          font-family: 'lato';
          font-size: 16px;
          line-height: 20px;
        }  
    }
   }
   .label-name-emp{
    width:41%;
    color: #9C9C9C;
   } 
`;

const NewProgressPointsV2 = styled.div`
width: 70%;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
// flex-wrap: wrap;
// margin: auto;
margin: auto 39px;
border-radius: 20px;
`;

const InitativeCard = styled.div`
.company-initative{
   width:100%;
   display: flex;
   background: #FFFFFF;
   flex-direction: column;
   margin-bottom:25px;
   border-radius: 6px;
}
.heading{
   color:#0D4270;
   font-family: 'lato';
   font-size: 18px;
   line-height:24px;
   margin-top: 25px;
   margin-left: 25px;
   display: flex;
   .total{
    font-family: 'lato';
    font-size: 18px;
    line-height: 24px;
    color: #FD7175
   }
}
.horizontal-line2{
  margin-top: 25px;
  margin-bottom: 25px;
  background: rgba(156, 156, 156, 0.4);
  width: 100%;
  height:1px;
  border: 0px;
}
.fitness-wrapper{
   display:flex;
   padding: 0px 0px 0px 25px;
   width:100%;
   flex-wrap:wrap;
   >div{
    .syncing-title{
      width: auto;
      font-family: 'lato';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      display:flex;
      // margin: auto;
      margin-left: 15px;
      // margin-bottom: 45px;
      // margin-top: 15px;
      flex-direction:column;
      color: #0D4270;
      // margin: auto;
      margin-left: 15px;
    }
    .points{
      // height: 20px;
      // left: 547px;
      // top: 1337px;
      font-family: 'lato';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      display: flex;
      align-items: center;
      // margin-right: -73px;
      // margin-top: 11px;
    }
   }
}
.syncing-fitness{
  width: calc((100% - 50px) / 3);
  height: 80px;
  border: 1px solid #9C9C9C;
  border-radius: 7px;
  display:flex;
  cursor: pointer;
  margin-bottom: 25px;
  .syncing-title{
    width: auto;
    height: 20px;
    font-family: 'lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    display:flex;
    margin: auto;
    margin-left: 15px;
    margin-bottom: 45px;
    margin-top: 15px;
    flex-direction:column;
   
  }
  .syncing-title2{
    width: 187px;
    height: 20px;
    font-family: 'lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    display:flex;
    margin: auto;
    margin-left: 15px;
    margin-bottom: 45px;
    margin-top: 15px;
    flex-direction:column;
  }
  .points{
    // height: 20px;
    // left: 547px;
    // top: 1337px;
    font-family: 'lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #F8A887;
    // margin-right: -73px;
    // margin-top: 11px;
  }
  .right-mark{
    width: 24px;
    height: 24px;
    margin-top: 28px;
    margin-bottom: 28px;
    margin-right: 10px;
  }
  .points2{
    width: 205px;
    height: 20px;
    left: 547px;
    top: 1337px;
    font-family: 'lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #F8A887;
    margin-right: -73px;
    margin-top: 11px;
  }
  .points3{
    width: 68px;
    height: 20px;
    left: 547px;
    top: 1337px;
    font-family: 'lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #F8A887;
    margin-right: -73px;
    margin-top: 11px;
  }
}
.rectangle-org{
  width: 60px
  height:60px
  border-radius: 4.2px;
  display:flex;
  margin: auto;
  margin-left: 10px;
  margin-right: 0px;
  >img{
    width:100%;
    height:100%
  }

}
.square-org{
  width: 60px
  height:60px
  background: linear-gradient(180deg, #FD7175 0%, #FF4C51 100%);
  border-radius: 4.2px;
  display:flex;
  margin: auto;
  margin-left: 10px;
  margin-right: 0px;
}
.cylinder-org{
  width: 60px
  height:60px
  background: linear-gradient(180deg, #C0ED98 0%, #96C26E 100%);
  border-radius: 4.2px;
  display:flex;
  margin: auto;
  margin-left: 10px;
  margin-right: 0px;
}
`;

const NewTotalPoints = styled.div`
width: calc((100% - 75px)/3);
display: flex;
background: #FFFFFF;
border: 1px solid rgba(156, 156, 156, 0.4);
border-radius: 6px;
margin-bottom: 20px;
margin-right: 25px;
height: 80px;
>div:first-child {
  width: 40%;
  padding: 10px;
  >img{
    width: 60px;
    height: 60px;
  }
}
>div:last-child {
    width: 200%;
    padding: 10px;
  >div:first-child{
    font-family: 'lato'
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #0D4270;
    //padding: 15px;
    text-transform: none;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
  }
  >div:last-child{
    font-family: lato;
    font-style: normal;
    font-weight: 500;
    font-size: 30px;
    line-height: 28px;
    //color: #32DBC6; 
    //padding: 15px;
    text-align: left;
    padding-top: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
   >span {
    font-size: 14px;
    line-height: 28px;
    font-family: 'lato';
    color: #0D4270;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
   } 
  }
 .step_cls {
   color: red;
 }
}
`;

const NewTotalPointsV2 = styled.div`
width: calc((100% - 75px) / 4);
display: flex;
background: #FFFFFF;
border: 1px solid rgba(156, 156, 156, 0.4);
border-radius: 6px;
margin-bottom: 20px;
margin-right: ${({marginRight}) => marginRight ? marginRight : '0px'};
height: 80px;
>div:first-child {
  width: 40%;
  padding: 10px;
  >img{
    width: 60px;
    height: 60px;
    background: linear-gradient(180deg, #1E6481 0%, #0D425C 60.94%, #022C43 100%);
    border-radius: 6px;
  }
}
>div:last-child {
    width: 200%;
    padding: 10px;
  >div:first-child{
    font-family: 'lato'
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #0D4270;
    //padding: 15px;
    text-transform: none;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
  }
  >div:last-child{
    font-family: lato;
    font-style: normal;
    font-weight: 500;
    font-size: 30px;
    line-height: 28px;
    //color: #32DBC6; 
    //padding: 15px;
    text-align: left;
    padding-top: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
   >span {
    font-size: 14px;
    line-height: 28px;
    font-family: 'lato';
    color: #0D4270;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
   } 
  }
 .step_cls {
   color: red;
 }
}
`;


const CountDiv = styled.div`

font-family: lato;
font-style: normal;
font-weight: 500;
font-size: 30px;
line-height: 28px;
//color: #32DBC6; 
color: ${({color}) => color ? 'color' : 'red'}; 
//padding: 15px;
text-align: left;
padding-top: 6px;
>span {
font-size: 14px;
line-height: 28px;
font-family: 'lato';
color: #0D4270;
}
`;

const WellnessCardV2 = styled.div`
width: calc((100% - 75px) / 4);
height: 60px;
border: 1px solid #9C9C9C;
border-radius: 7px;
margin-bottom: 15px;
display: flex;
margin-right: ${({marginRight}) => marginRight ? marginRight : '25px'};
  .wellness-interest{
    margin: 10px 0px;
    max-width: 1246px;
    background-color:#FFFFFF;
    border-radius: 6px;
  }
  .wellness-title{
    padding: 25px;
  }
  .title-text{
    font-family: 'lato';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #0D4270;    
    margin-right: 25px;
  }
  .wellness-count{
    font-family: 'lato';
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;    
    color: #FD7175
  }
  .interest-card-wrapper{
    padding:25px;
    padding-bottom: 7px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .horizontal-line{
    border: 1px solid rgba(156, 156, 156, 0.4);
    margin-top: unset;
    margin-bottom: unset;
  } 
  .interest-card{
    width: 23.5%;
    height: 60px;
    border: 1px solid #9C9C9C;
    border-radius: 7px;
    margin-bottom: 20px;
  }

  .icon-wrapper{
    display: flex;
    align-items: center;
    padding: 10px;
  }
  .interest-card{
  display:flex;
  }
  .interest-icon{
    height: 40px;
    width: 40px;
    display: flex;
    background: #0D4270;
    align-items: center;
    border-radius: 6px;
    >img{
      width: 25px;
      height: 25px;
      margin: auto;
    }
  }
  .interest-name{
    display: flex;
    align-items: center;
    font-family: 'lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #0D4270;
  }
`;

const OverviewCardV2 = styled.div`
    max-width: 1246px;
    height:  ${({height}) => height ? '414px' : '189px'};
    background-color:#FFFFFF;
    border-radius: 6px;
    margin-bottom: 25px;
.viewcard{
    display:flex;  
    justify-content:space-between;
    
  }
   .prof-details{
      width:100%;
      display:flex;
      justify-content:space-between;
      padding: 0px 25px 0px 25px;
      height:74px;
   }
   .name-in{
    display: flex;
    font-family:"lato";
      font-style: normal;
      align-items: center;
      color: #0D4270;
      font-size: 18px;
      line-height: 24px;
   }
    .horizontal-line{
        background: rgba(156, 156, 156, 0.4);
        margin-bottom: 25px;
        margin-top: 0px;
        height: 1px
    }
    .user-edit-btn{
      background: #FD7175;  
      min-width: 150px;
      height: 40px;
      border-radius: 3px;
      color: white;
      border:none;
      font-size:18px;
      font-family: "lato";
      align-items: center;
      display: flex;
      margin: auto;
      margin-right: 0px;
      text-align: center;
      justify-content: center;
   }
   .emp-detail{
    font-family: 'lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    display:flex;
    flex-wrap:wrap;
    display: flex;
    flex-direction: ${({flex}) => flex ? 'column' : 'row'};
    padding: 0px 25px;
    
    .fieldNames{
        width: ${({fieldWidth}) => fieldWidth ? '75%' : '50%'};
        display: flex;
        height: 40px;
        .color{
          color:#FD7175;
          font-family: 'lato';
          font-size: 16px;
          line-height: 20px;
        }
        .green{
          color: #9FC989;
          font-family: 'lato';
          font-size: 16px;
          line-height: 20px;
        }
        .prof-data{
          color:#0D4270;
          font-family: 'lato';
          font-size: 16px;
          line-height: 20px;
        }  
    }
   }
   .label-name-emp{
    width: ${({labelWidth}) => labelWidth ? '65%' : '40%'};
    color: #9C9C9C;
   } 
`;

const WbaPoints = styled.div`
width: calc((100% - 55px)/3);
display: flex;
background: #FFFFFF;
border: 1px solid rgba(156, 156, 156, 0.4);
border-radius: 6px;
margin-bottom: 20px;
margin-right: ${({marginRight}) => marginRight ? marginRight : '0px'};
height: 80px;
>div:first-child {
  width: 40%;
  padding: 10px;
  >img{
    width: 60px;
    height: 60px;
  }
}
>div:last-child {
    width: 200%;
    padding: 10px;
  >div:first-child{
    font-family: 'lato'
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #0D4270;
    //padding: 15px;
    text-transform: none;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
  }
  >div:last-child{
    font-family: lato;
    font-style: normal;
    font-weight: 500;
    font-size: 30px;
    line-height: 28px;
    //color: #32DBC6; 
    //padding: 15px;
    text-align: left;
    padding-top: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
   >span {
    font-size: 14px;
    line-height: 28px;
    font-family: 'lato';
    color: #0D4270;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
   } 
  }
 .step_cls {
   color: red;
 }
}
`;

const ActivityBar = styled.div`
    width: ${(props) => props.width ? props.width : '100%'};
    height: 15px;
    border-radius: 20px;
    background-color: ${(props) => props.backgroundFill ? props.backgroundFill : 'rgba(86, 192, 36, 0.3)'};
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: ${(props) => props.margin ? props.margin : '5px 0px'}
`;

const ActivityBarFill = styled.div`
    // width: ${(props)=> props.width ? props.width : '0%'};
    width: ${(props) => props.width ? (parseFloat(props.width) > 100 ? '100%' : props.width) : '0%'};
    height: 100%;
    border-radius: 20px;
    background-color: ${(props) => props.fillColor ? props.fillColor : '#000'};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 0px 0px 0px;
    position: absolute;
    top: 0px;
    > span {
     cursor : pointer;
     color: #fff;
     font-size: 11px;
     font-family: ${BoldFont};
     display: inline-block;
   }
`;

const ActivityContainer = styled.div`
    width: ${({width}) => width ? width : '100%'};
    font-size: 13px;
    margin: ${({bloodPressure}) => bloodPressure ? bloodPressure : '15px 0px'};
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .chartTitle {
        color: #000;
        font-family: ${BoldFont}
        display: inline-block;
        margin-right: 5px;
    }
    .sliderTitle {
      font-family: ${BoldFont};
      font-size: 14px;
      color: #282C37;
    }
    .chartSubTitle {
        color: #C9CACC;
        font-family: ${MediumFont};
        display: inline-block;
    }
    
    @media (max-width: 1175px) and (min-width:1024px) {
      width: ${({width}) => width ? '85%'  : '100%'};
    }
    
    @media (max-width: 1023px) and (min-width:950px) {
      width: ${({width}) => width ? '80%'  : '100%'};
    }
    
    @media (max-width: 949px) and (min-width:850px) {
      width: ${({width}) => width ? '85%'  : '100%'};
    }
    @media (max-width: 500px) {
       width: ${({width}) => width ? '100%'  : '100%'};
    }
`;

const ShowPoints = styled.div`
  width: 43px;
  height: 20px;
  font-family: 'lato';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #0D4270;
  margin-left: 10px;
`;

const ActivityBarV2 = styled.div`
    width: ${(props) => props.width ? props.width : '100%'};
    height: 15px;
    border-radius: 20px;
    background-color: ${(props) => props.backgroundFill ? props.backgroundFill : 'rgba(86, 192, 36, 0.3)'};
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: ${(props) => props.margin ? props.margin : '5px 0px'}
`;

const ActivityBarFillV2 = styled.div`
    width: ${(props)=> props.width ? props.width : '0%'};
    height: 100%;
    border-radius: 20px;
    background-color: ${(props) => props.fillColor ? props.fillColor : '#000'};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 15px 0px 12px;
    position: absolute;
    top: 0px;
    > span {
     cursor : pointer;
     color: #fff;
     font-size: 11px;
     font-family: ${BoldFont};
     display: inline-block;
   }
`;

const ContainerV2 = styled.div`
  width: 100%;
  display:flex;
  justify-content:space-between;
  .text{
    text-align: left;
    font-family: lato;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: rgb(255, 255, 255);
  }
  .image{
    width:20px;
    height:20px;
    display:flex;
    margin:auto 0px auto auto;
    cursor:pointer;
    >img{
      width:20px;
      height:20px;
    }
  }
`;

const YearDisplay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
`;

const WbaPointsV2 = styled.div`
width: 365px;
display: flex;
background: #FFFFFF;
border: 1px solid rgba(156, 156, 156, 0.4);
border-radius: 6px;
margin-bottom: 20px;
margin-right: ${({marginRight}) => marginRight ? marginRight : '0px'};
height: 80px;
>div:first-child {
  width: 40%;
  padding: 10px;
  >img{
    width: 60px;
    height: 60px;
  }
}
>div:last-child {
    width: 200%;
    padding: 10px;
  >div:first-child{
    font-family: 'lato'
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #0D4270;
    //padding: 15px;
    text-transform: none;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
  }
  >div:last-child{
    font-family: lato;
    font-style: normal;
    font-weight: 500;
    font-size: 30px;
    line-height: 28px;
    //color: #32DBC6; 
    //padding: 15px;
    text-align: left;
    padding-top: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
   >span {
    font-size: 14px;
    line-height: 28px;
    font-family: 'lato';
    color: #0D4270;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
   } 
  }
 .step_cls {
   color: red;
 }
}
`;

const InitativeCardV2 = styled.div`
width: calc((100% - 50px) / 3);
height: 80px;
border: 1px solid #9C9C9C;
border-radius: 7px;
display:flex;
// cursor: pointer;
margin-bottom: 15px;
margin-right: ${({marginRight}) => marginRight ? marginRight : '25px'};
.syncing-title-value{
  .points-value{
    color: ${({color}) => color ? color : '#0D4270'};
  }
}
.syncing-title-value{
  width: auto;
  font-family: 'lato';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  // margin-bottom: 45px;
  // margin-top: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-evenly;
  flex-flow: column;
  margin: 0px;
  padding-right: 5px;
  margin-left: 15px;
}
.company-initative{
   width:100%;
   display: flex;
   background: #FFFFFF;
   flex-direction: column;
   margin-bottom:25px;
}
.heading{
   color:#0D4270;
   font-family: 'lato';
   font-size: 18px;
   line-height:24px;
   margin-top: 25px;
   margin-left: 25px;
}
.horizontal-line2{
  margin-top: 25px;
  margin-bottom: 25px;
  background: rgba(156, 156, 156, 0.4);
  height: 1px;
  border: 0px;
  width: 100%;
}
.fitness-wrapper{
   display:flex;
   justify-content: space-between;
   padding: 0px 25px 0px 25px;
   width:100%;
   flex-wrap:wrap;
}
.syncing-fitness{
  width: calc((100% - 50px) / 3);
  height: 80px;
  border: 1px solid #9C9C9C;
  border-radius: 7px;
  display:flex;
  cursor: pointer;
  margin-bottom: 25px;
  .syncing-title-value{
    width: auto;
    font-family: 'lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    // margin-bottom: 45px;
    // margin-top: 15px;
    flex-direction: column;
    display: flex;
    justify-content: space-evenly;
    flex-flow: column;
    margin: 0px;
    padding-right: 5px;
    margin-left: 15px;
  }
  .syncing-title2{
    width: 187px;
    height: 20px;
    font-family: 'lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    display:flex;
    margin: auto;
    margin-left: 15px;
    margin-bottom: 45px;
    margin-top: 15px;
    flex-direction:column;
  }
  .points-value{
    height: 20px;
    font-family: 'lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #F8A887;
    margin-top:0px;
  }
  .points2{
    width: 205px;
    height: 20px;
    left: 547px;
    top: 1337px;
    font-family: 'lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #F8A887;
    margin-right: -73px;
    margin-top: 11px;
  }
  .points3{
    width: 68px;
    height: 20px;
    left: 547px;
    top: 1337px;
    font-family: 'lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #F8A887;
    margin-right: -73px;
    margin-top: 11px;
  }
}
.rectangle-org{
  width: 60px;
  height:60px;
  border-radius: 4.2px;
  display:flex;
  margin: auto;
  margin-left: 10px;
  margin-right: 0px;
  >img{
    width:100%;
    height:100%;
  }
}
.right-mark{
  margin: auto;
  margin-right: 10px;
}
.square-org{
  width: 60px
  height:60px
  background: linear-gradient(180deg, #FD7175 0%, #FF4C51 100%);
  border-radius: 4.2px;
  display:flex;
  margin: auto;
  margin-left: 10px;
  margin-right: 0px;
}
.cylinder-org{
  width: 60px
  height:60px
  background: linear-gradient(180deg, #C0ED98 0%, #96C26E 100%);
  border-radius: 4.2px;
  display:flex;
  margin: auto;
  margin-left: 10px;
  margin-right: 0px;
}
`;

const TabButton = styled.div`
 display:flex;
 height:40px;
 min-width:100px;
 padding: 0px 10px;
 margin-right:15px; 
 align-items: center;
 font-family: ${({active}) => active ? "lato" : 'lato'};
 font-size: 16px;
 line-height: 20px;
 color: ${({active}) => active ? "white" : 'rgb(156, 156, 156)'};
 background: ${({active}) => active ? "#69c2ff" : 'transparent'};
 border: ${({active}) => active ? "none" : '1px solid rgb(156, 156, 156)'};
 border-radius:3px;
 cursor:pointer;
 justify-content: center;
`;



const InterestCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 14px 16px;
  width: 100%;

  .interest-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  .interestType {
    color: #989898;
    font-family: 'Lato';
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    text-transform: capitalize;
  }

  .dropicon {
    transition: transform 0.3s ease;
  }

  .dropdown-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
  }

  @media (max-width: 600px) {
    .interestType {
      font-size: 14px;
    }
  }

  .title{
    color: #184A61;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
    margin:16px 0px;
  }
`;


const DropdownContent = styled.div`
  display: flex;
  height: 40px;
  padding: 8px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 40px;
  border: 1px solid #EFEFEF;
  background: ${({ userInterest,background }) => (userInterest ? background ? background : "#F37A65" : "white")};
  font-weight: 600;
  color: ${({ userInterest }) => (userInterest ? "white" : "#184A61")};
  cursor: pointer;
  transition: background 0.3s;

  > img {
    width: 24px;
    height: 24px;
  }


  .category-img {
    width: 24px;
    height: 24px;
    transition: filter 0.3s ease;
    filter: ${({ userInterest }) =>
    userInterest ? "brightness(0) invert(1)" : "none"};
  }

  .listContent {
    color: ${({ userInterest }) => (userInterest ? "white" : "#184A61")};
    font-family: 'Lato';
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
  }

  @media (max-width: 480px) {
    flex: 1 1 100%;
    justify-content: flex-start;
    padding: 8px;
  }
`;


const WellnessCardNew = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 12px;
  background: var(--Light-Card, rgba(254, 254, 254, 0.60));
  margin-bottom: 20px;
  width: 100%;

  .heading-row {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }

  .edit-btn {
    color: #184A61;
    font-family: Lato;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    cursor: pointer;
  }

  .pencil-icon {
    margin-left: 8px;
  }

  .heading {
    color: #184A61;
    font-family: Lato;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
  }

  .headerContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .wellness-interest {
    display: flex;
    flex-wrap: wrap;
    gap: 20px 8px;
    width: 100%;
  }

  .wellnessTypeContainer {
    display: flex;
    padding: 12px 8px;
    align-items: center;
    gap: 12px;
    border-radius: 12px;
    background: var(--Light-Card, rgba(254, 254, 254, 0.60));
    min-width: 24%;
    max-width: 100%;

    .contentHeading {
      color: #184A61;
      font-family: Lato;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }

    .value {
      color: #184A61;
      font-family: Lato;
      font-size: 18px;
      font-weight: 700;
      line-height: 20px;
    }
  }

  .iconWrapper {
    display: flex;
    width: 48px;
    height: 48px;
    justify-content: center;
    align-items: center;
    border-radius: 40px;
    background: ${({ isColor }) => isColor || '#92A4DA'};
  }

  .activity-name,
  .activity-count {
    color: #184A61;
    font-family: Lato;
  }

  .activity-name {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-transform: capitalize;
  }

  .activity-count {
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
  }

  @media (max-width: 1024px) {
    .wellnessTypeContainer {
      flex: 1 1 calc(33.33% - 16px);
    }
  }

  @media (max-width: 768px) {
    .wellnessTypeContainer {
      flex: 1 1 calc(50% - 16px);
    }
  }

  @media (max-width: 480px) {
    .wellnessTypeContainer {
      flex: 1 1 100%;
    }
  }
`;



const IconWrapper = styled.div`
 display: flex;
  width: 48px;
  height: 48px;
  ${'' /* padding: 30px 10px; */}
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 40px;
  background: ${({isColor}) => isColor ? isColor : '#92A4DA'};
  `;


const WbaReportCard = styled.div`
width:100%;
display:block;
padding: 20px 16px 16px 16px;
background: rgba(254, 254, 254, 0.60);
border-radius:12px;
margin-bottom:20px;
border:1px solid #DCDCDC;
padding-right:10px;

.no-data{
  color:#184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
}

.no-data-text{
  color:#184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
}

.no-data-icon{
  position:absolute;
  bottom:0;
  right:0;
}
.new-start{
  display:flex;
  justify-content:space-between;
  width:100%;
  .title{
      color: #184A61;
      font-family: Lato;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
      display:flex;
      align-items:center;
    }

    .icon{
      margin-right:4px;
    }

}
.heading{
  width:100%;
  display:flex;
  align-items:center;
  .start{
    display:flex;
    .icon{
      margin: auto 8px auto 12px;
      cursor:pointer;
    }
    .title{
      color: #184A61;
      font-family: Lato;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
      display:flex;
      align-items:center;
    }
    .line{
      width:1px;
      display:flex;
      height:auto;
      background: #EFEFEF;
      margin:0 12px;
    }
    .total{
      color: #184A61;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
      display:flex;
      align-items:center;
    }
    .icon{
      margin-left:4px;
    }
  }
  .end{
    display:flex;
    margin:auto 0 auto auto;
    align-items: center;
    .icon{
      margin-left:8px;
      cursor:pointer;
    }
    .view-report{
      color: #184A61;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin-left:8px;
      cursor:pointer;
    }
  }
}
.border{
  width:100%;
  height:1px;
  background: #EFEFEF ;
  margin: 24px auto 24px auto;
  border:none !important;
}
.category-wrapper{
  display:flex;
  flex-wrap:wrap;
  gap:16px
}
.category-wrapper-new{
  display:flex;
  flex-wrap:wrap;
  flex-direction:column;
  border-radius: 8px;
  border: 1px solid #DCDCDC;
  background: #FEFEFE;
  padding:20px;

  .total{
      color: #184A61;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
      display:flex;
      align-items:center;
    }
}
.biometric-complete{
  color: #989898;
  width:100%;
  justify-content:center;
  text-align: center;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}

.biometric-complete-new{
  color:#184A61;
text-align: center;
font-family: Lato;
font-size: 12px;
font-style: normal;
font-weight: 700;
line-height: 14px; /* 116.667% */
}

.biometric-card{
  border-radius: 8px;
  border: 0.75px solid #DCDCDC;
  background: #FEFEFE;
  padding:20px;
  margin-top:18px;
}
`;

const WbaCatgoryCard = styled.div`
  width:240px;
  display:flex;
  justify-content:center;
  flex-wrap:wrap;
  .bar{
  width: 100%;
  margin: auto;
  display: flex;
  margin-bottom: 0px;
}

  .category{
    display:flex;
    width:100%;
    justify-content:center;
    align-items:center;
  }
  .category-name{
    display:flex;
    justify-content:center;
    width:100%;
    color: #184A61;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-bottom:12px;
  }
  .category-name-new{
    display:flex;
    justify-content:center;
    color: #184A61;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-left:8px;
  }
  .progress-container {
    position: relative;
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .progress-ring {
    transition: stroke-dashoffset 0.5s ease-in-out;
    transform: rotate(-90deg);
    transform-origin: center;
    stroke-linecap: round; /* This makes the ends rounded (border-radius effect) */
  }
  
  .progress-text {
    position: absolute;
    font-family: Lato;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px
    color:#184A61;
  }

`;

const ReportHeading = styled.div`
width:100%;
display:flex;
padding: 15px;
background: rgba(254, 254, 254, 0.60);
border-radius: 12px;
align-items:center;
margin-bottom:20px;
border:1px solid #DCDCDC;
.title{
  color: #184A61;
  text-align: center;
  font-family: Lato;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

.icon-background{
  display: flex;
  width: 32px;
  height: 32px;
  padding: 7px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 4px;
  background: var(--Crimson-Blush-100, #FCF2F3);

}

.left-section {
    display: flex;
    align-items: center;
  }

  .right-section {
    display: flex;
    align-items: center;
    margin-left: auto;
  }
.icon{
  margin-right:20px;
  cursor:pointer;
}

.edit-icon{
  margin-left:20px;
  cursor:pointer;
}


`;

const CategoryCard = styled.div`
width:15.5%;
display:flex;
background: rgba(254, 254, 254, 0.60);
border-radius: 8px;
padding: 12px 8px;

cursor:pointer;
border: ${({active}) => active ? '1px solid #DA6C74' : '1px solid #DCDCDC'};
.category {
    color: #184A61;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
}
.icon{
  width:48px;
  height:48px;
  border-radius:50%;
  margin-right:12px;
  background: ${({color}) => color ? color : '#0D4270'};
  display:flex;
  >img{
    width:24px;
    height:24px;
    margin:auto;
    filter: invert(1) brightness(1000%);
  }
}
.wrap{
  display:block;
  .catgeory{
    color: #184A61;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
  .score{
    color: #184A61;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }
}
`;

const QueAnsWrapper = styled.div`
width:100%;
display:flex;
padding: ${({padding}) => padding ? padding : '16px'};
background: ${({color}) => color ? color : 'rgba(254, 254, 254, 0.60)'};
border-radius: 8px;
margin-top:20px;
margin-top: ${({margin}) => margin ? margin : '16px'};
border: ${({showBorder}) => showBorder ? '1px solid #DCDCDC' : 'unset'};
.wrapper{
  display:flex;
  background: #FEFEFE;
  border-radius: 8px;
  padding: 20px 0px 20px 20px;
  flex-wrap:wrap;
  width:inherit;
  border:1px solid #DCDCDC;
  .border{
    width:100%;
    background: #EFEFEF;
    height:1px;
    margin: 12px 0;
    border: none !important;
  }
  .content{
    width:100%;
    display:flex;
    .question{
      color: #989898;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      width:598px;
      display:flex;
      padding-right:8px;
    }
    .answer{
      color:  #184A61;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
      width:598px;
      display:flex;
      margin-left:4px;
      padding-right:8px;
    }
  }
}
`;

const BiometricCard = styled.div`
width:235px;
display:flex;
padding: 12px 8px;
background: rgba(254, 254, 254, 0.60);
border-radius:4px;
gap: 12px;
.circle{
  width:12px;
  height:12px;
  background: ${({color}) => color ? color : '#0D4270'};
  border-radius:50%;
  display:flex;
  align-items:center;
  display: flex;
  margin: auto 0;
}
.wrap{
  display:block;
  .field{
    color: #184A61;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
  .value{
    color: #184A61;
    font-family: Lato;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px;
  }
}
`;

const NewBiometricCard = styled.div`

${'' /* padding: 12px 8px; */}
background: rgba(254, 254, 254, 0.60);
border-radius:4px;
${'' /* gap: 12px; */}
.value-container{
  display:flex;
}

.wrap{
  width:100%;
display:flex;
justify-content:space-between;

}
.circle{
  width:12px;
  height:12px;
  background: ${({color}) => color ? color : '#0D4270'};
  border-radius:50%;
  display:flex;
  align-items:center;
  display: flex;
  margin: auto 0;
}
.field{
    color: #184A61;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
  .value{
    color: #184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 20px;
    margin-left:8px;
  }

  .biometric-complete{
    color: #184A61;
text-align: center;
font-family: Lato;
font-size: 12px;
font-style: normal;
font-weight: 700;
line-height: 14px;

  }
`;

const BiometricInfoCard = styled.div`
width:100%;
display:flex;
margin-bottom:8px;
padding:0 16px;
align-items: center;
.color{
  background: ${({color}) => color ? color : '#0D4270'};
  width:8px;
  height:8px;
  align-items:center;
  display:flex;
  margin-right:8px;
  border-radius:50%;
}
.text{
  color: #184A61;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
`;

const InitiativesCard = styled.div`
width:23.7%;
display:flex;
padding: 12px 8px;
background: rgba(254, 254, 254, 0.60);
border-radius: 8px;
border: 1px solid #DCDCDC;
.icon{
  width:48px;
  height:48px;
  border-radius:50%;
  display:flex;
  align-items:center;
  margin: auto 0;
  background: ${({color}) => color ? color : '#0D4270'};
  >img{
    width:24px;
    height:24px;
    display:flex;
    justify-content:center;
    align-items:center;
    margin:auto;
  }
}
.wrap{
  display:block;
  margin-left:12px;
  .title{
    color: #184A61;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
  .points{
    color: #184A61;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    margin-top:4px;
  }
  .completed{
    color: #989898;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-top:12px;
  }
  .initiative-button{
    width:140px;
    display:flex;
    padding: 6px 12px;
    border-radius: 6px;
    background-color: transparent;
    border: 0.75px solid #DA6C74;
    color: #184A61;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    gap:8px;
    align-items:center;
    justify-content:center;
    margin-top:12px;
    cursor:pointer;
  }
}
`;

const GeneralInfoPopup = styled.div`
display:block;
.title{
  color: #184A61;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-bottom:12px;
}
.dropdown{
  display:flex;
  dropdown-basic{
    width:100%;
  }
}
`;


const OuterCardContainer = styled.div`
{
    width: 1248px;
    height:264px;
    display: flex;
    justify-Content: center;
    border: 1px solid #DCDCDC;
    padding: ${({ isOuterpadding }) => (isOuterpadding ? isOuterpadding : "0px 20px 46px 20px")};
    ${'' /* padding: 0px 20px 46px 20px; */}
    margin-Top: 20px;
    border-Radius: 12px;
    background: #FEFEFE;


    .insideCard{
        display: flex;
        height:176px;
        margin-top:16px;
        padding: 20px;
        flex-direction: row;          /* <-- Row layout */
        justify-content: space-between; /* Left text + Right icon separated */
        align-items: flex-end;  
        align-self: stretch;
        border-radius: 8px;
        border: 1px solid var(--Bg-Color-for-Light-theme-300, #DCDCDC);

        .fitContainer{
          display:flex;
          gap:16px;


        .fitText{
          color: var(--Font-Color-on-Light-theme-500, #184A61);
          font-family: Lato;
          font-size: 32px;
          font-style: normal;
          font-weight: 700;
          line-height: 48px; /* 120% */
        }

        .lastSyncText{
          color: var(--Font-Color-on-Light-theme-500, #184A61);
          text-align: center;
          font-family: Lato;
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          line-height: 24px; 
        }
        }


        .watchIconWrapper {
         ${'' /* flex-shrink: 0;
         display: flex;
         align-items: center;
         justify-content: center;
         width: 150px;
         background-image: ${({ bgImage }) => `url(${bgImage})`};
         background-size: cover;
         background-repeat: no-repeat;
         background-position: center; */}
         flex-shrink: 0;
         width: 150px;
         height: 155px;   /* <-- ADD THIS */
         display: flex;
         top:20px;
         right:-21px;
         position:relative;
         align-items: center;
         justify-content: center;
         background-image: ${({ bgImage }) => `url(${bgImage})`};
         background-size: contain;
         background-repeat: no-repeat;
         background-position: center;
         }

    }

}
`;


const ConnectedDevice =styled.div`
    display: flex;
    width: 80px;
    height: 80px;
    ${'' /* padding: 75px 25px; */}
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    aspect-ratio: 1/1;
    border-radius: 100px;
    border: 0.5px solid var(--Bg-Color-for-Light-theme-200, #BDBDBD);
    ${'' /* background: url(<path-to-image>) lightgray 50% / cover no-repeat; */}
`;


const OuterCardWrapper = styled.div`
    font-size: 18px;
    font-family: Lato;
    font-weight: 700;
    line-height: 24px;
    color: #184A61;
    border-top: 1px solid #DCDCDC;
    padding: 11px;
    border-left: 1px solid #DCDCDC;
    border-right: 1px solid #DCDCDC;
    border-radius: 12px 12px 0px 0px;
    background: #FEFEFE;
`;



export {
  NotificationWrapper, TitleContainer,OuterCardWrapper, UserImage, WellnessIntereset, Content, WellnessInitiative, WellnessInitiativeRow, ActivityContainer, ActivityBarFill, ActivityBar, ShowPoints,
  InitiativeTitle, WellnessPoint, TickWrapper, Container, LocationContainer, StyledModal, AboutCard, WellnessCard, StyledModalV2, StyledBody, TopInfo, AboutTextBox, SaveAboutButton, OverviewCard, NewProgressPointsV2, NewTotalPoints, CountDiv, InitativeCard, WellnessCardV2, NewTotalPointsV2, OverviewCardV2, WbaPoints, ActivityBarFillV2, ActivityBarV2, StyledModalV3, WbaCardContainer, FirstRowCard, LastImprovementRow, ContainerV2, YearDisplay, FirstRowCardV2, WbaPointsV2, InitativeCardV2, TabButton,
  WbaReportCard, WbaCatgoryCard, BiometricCard,WellnessCardNew,IconWrapper,DropdownContent,InterestCard, ReportHeading, CategoryCard, QueAnsWrapper, BiometricInfoCard, InitiativesCard, GeneralInfoPopup, NewBiometricCard,OuterCardContainer,ConnectedDevice
}